import vueComponentOptions from 'components/InputMedia.vue';

const MediaInput = Vue.extend(vueComponentOptions);

module.exports = MediaInput;
